import { Radio, RadioGroup } from "@/components/radio-group";
import { cn } from "@/utils/cn";

type SegmentedRadioGroupProps = {
  isDisabled: boolean;
  labelledBy: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  value: null | string;
};

export function SegmentedRadioGroup({
  isDisabled,
  labelledBy,
  onChange,
  options,
  value,
}: SegmentedRadioGroupProps) {
  return (
    <RadioGroup
      aria-labelledby={labelledBy}
      className="mt-3.5 flex gap-1 rounded-xl border border-border-primary bg-bg-primary p-1"
      isDisabled={isDisabled}
      onChange={onChange}
      orientation="horizontal"
      value={value}
    >
      {options.map((option) => (
        <Radio
          className="flex-1"
          key={option.value}
          render={({ isFocusVisible, isSelected }) => (
            <span
              className={cn(
                "flex h-9 cursor-pointer items-center justify-center rounded-lg text-sm font-semibold text-text-tertiary",
                isSelected && "bg-bg-brand-solid font-bold text-text-white",
                isFocusVisible && "ring-2 ring-border-brand",
              )}
            >
              {option.label}
            </span>
          )}
          value={option.value}
        />
      ))}
    </RadioGroup>
  );
}
